import PropTypes from 'prop-types';
import { useCallback } from 'react';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { fetchCompletedCourses } from '@actions/courses';
import { useDispatchToStore } from '@hooks/reduxHooks';
import useEnroll from '@hooks/useEnroll';
import Dialog from '@comp/Dialog/Dialog';
import { getCompletedCoursesFeed } from '@selectors/syllabus';
import { staticStrings } from '@constants/index';
import { Spacings } from '@styles/index';
import PaginatedContainer from './PaginatedContainer';
import { enrollProps } from './syllabusHelper';
import BlockWrapper from './BlockWrapper';
import PlusCard from './PlusCard';

const StyledPlusCard = styled(PlusCard)`
  margin-bottom: ${Spacings.SPACING_2B};
`;

const CompletedCourses = ({ topic }) => {
  const feedBlock = useSelector((state) =>
    getCompletedCoursesFeed(state, topic.uid)
  );
  const dispatch = useDispatchToStore();
  const { isUnEnrollModalOpen, toggleEnroll, acceptOnClick, onCloseModal } =
    useEnroll(enrollProps);
  const loadMore = useCallback(() => {
    dispatch(fetchCompletedCourses(topic.uid, true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topic.uid]);
  const renderBlock = useCallback(
    (courseData, index) => {
      return (
        <StyledPlusCard
          key={courseData.course}
          courseData={courseData}
          toggleEnroll={toggleEnroll}
          index={index}
          showProgress
          orientation="vertical"
          gridColumn="span 6"
        />
      );
    },
    [toggleEnroll]
  );
  if (!feedBlock.results.length) return null;
  return (
    <BlockWrapper>
      <PaginatedContainer
        feedBlock={feedBlock}
        loadMore={loadMore}
        title="My completed courses"
        _renderItem={renderBlock}
      />
      <Dialog
        onClose={onCloseModal}
        dialogState={isUnEnrollModalOpen}
        heading="Are you sure you want to unenroll?"
        message={staticStrings.UNENROLL_MESSAGE}
        acceptLabel="Unenroll"
        rejectLabel="Cancel"
        acceptOnClick={acceptOnClick}
        rejectOnClick={onCloseModal}
      />
    </BlockWrapper>
  );
};

CompletedCourses.propTypes = {
  topic: PropTypes.objectOf(PropTypes.string).isRequired
};

export default CompletedCourses;
